"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactCollapse = require("react-collapse");
var _Icon = require("b2b-components/theme/components/Icon");
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _index = require("./index");
require("./Section.scss");
var Section = function Section(_ref) {
  var children = _ref.children,
    index = _ref.index,
    _onClick = _ref.onClick,
    title = _ref.title,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    _ref$titleSize = _ref.titleSize,
    titleSize = _ref$titleSize === void 0 ? _index.TITLE_SIZE["default"] : _ref$titleSize,
    _ref$arrowPosition = _ref.arrowPosition,
    arrowPosition = _ref$arrowPosition === void 0 ? _index.ARROW_POSITION.left : _ref$arrowPosition,
    className = _ref.className,
    titleClassName = _ref.titleClassName,
    contentClassName = _ref.contentClassName;
  var id = (0, _key.generateUnique)();
  var ariaControls = "".concat(_index.SECTION_ELEMENT_ID.content, "-").concat(id, "-").concat(index);
  var ariaLabelledBy = "".concat(_index.SECTION_ELEMENT_ID.heading, "-").concat(id, "-").concat(index);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('cds-Accordion-Section', {
      'cds-Accordion-Section--Open': isOpen
    }, className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: ariaLabelledBy,
    "aria-controls": ariaControls,
    "aria-level": 1,
    onClick: function onClick() {
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick();
    },
    onKeyPress: function onKeyPress() {
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick();
    },
    role: "heading",
    className: (0, _classnames["default"])('cds-Accordion-SectionTitle', (0, _defineProperty2["default"])({
      'cds-Accordion-SectionTitle--Open': isOpen
    }, "cds-Accordion-SectionTitle--".concat((0, _upperCaseFirst.upperCaseFirst)(titleSize)), titleSize !== _index.TITLE_SIZE["default"]), {
      'cds-Accordion-SectionTitle--ArrowRight': arrowPosition === _index.ARROW_POSITION.right
    }, titleClassName)
  }, arrowPosition === _index.ARROW_POSITION.left && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: "cds-Accordion-SectionTitle-ArrowIcon",
    name: _Icon.Icon.config.name.arrowDown,
    size: titleSize === _index.TITLE_SIZE.large ? _Icon.Icon.config.size.small : _Icon.Icon.config.size.xsmall
  }), /*#__PURE__*/_react["default"].createElement("div", null, title), arrowPosition === _index.ARROW_POSITION.right && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: "cds-Accordion-SectionTitle-ArrowIcon",
    name: _Icon.Icon.config.name.arrowDown,
    size: titleSize === _index.TITLE_SIZE.large ? _Icon.Icon.config.size.small : _Icon.Icon.config.size.xsmall
  })), /*#__PURE__*/_react["default"].createElement(_reactCollapse.Collapse, {
    isOpened: isOpen
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: ariaControls,
    "aria-labelledby": ariaLabelledBy,
    role: "region",
    className: (0, _classnames["default"])('cds-Accordion-SectionContent', contentClassName)
  }, children)));
};
exports.Section = Section;